import { createApp } from "vue";
import App from "./app/app.vue";
import router from "./router";
import store from "./store";

import { library } from "@fortawesome/fontawesome-svg-core";
import { faEnvelope, faLock, fas } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { vMaska } from "maska";
import money from "v-money";
import excel from "vue-json-excel3";
import Toast, { PluginOptions } from "vue-toastification";

import "./index.scss";

import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue-next/dist/bootstrap-vue-next.css";
import { BTabs, BTab } from "bootstrap-vue-next";
import PrimeVue from "primevue/config";
import MultiSelect from "primevue/multiselect";
import "primeicons/primeicons.css";

// eslint-disable-next-line @typescript-eslint/no-var-requires
const BootstrapVueNext = require("bootstrap-vue-next");
import Aura from "@primeuix/themes/aura";
import Tooltip from "primevue/tooltip";

library.add(fas, faLock, faEnvelope);

const options: PluginOptions = {
  timeout: 5000,
  closeOnClick: true,
  pauseOnFocusLoss: true,
  pauseOnHover: true,
  draggable: true,
  draggablePercent: 0.6,
  showCloseButtonOnHover: false,
  hideProgressBar: false,
  closeButton: "button",
  icon: true,
  rtl: false,
};

createApp(App)
  .component("font-awesome-icon", FontAwesomeIcon)
  .component("downloadExcel", excel)
  .component("b-tabs", BTabs)
  .component("b-tab", BTab)
  .use(store)
  .use(router)
  .use(BootstrapVueNext)
  .use(Toast, options)
  .directive("maska", vMaska)
  .directive("tooltip", Tooltip)
  .use(money, { precision: 2 })
  .use(PrimeVue, { ripple: true, theme: { preset: Aura } })
  .component("MultiSelect", MultiSelect)
  .mount("#app");
